var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSelector } from 'reselect';
import theme from 'themes/default';
import { reversePalette } from 'styled-theme/composer';
import { darken } from 'polished';
import { fromJS } from 'immutable';
var buildPalette = function (colors) {
    var pureColors = colors.toJS();
    var activePrimaryHighlight = darken(0.07, colors.get('primaryHighlight')) ||
        theme.palette.activePrimaryHighlight;
    var activeSecondaryBackground = darken(0.07, colors.get('secondaryBackground')) ||
        theme.palette.activeSecondaryBackground;
    var activeSecondaryHighlight = darken(0.07, colors.get('secondaryHighlight')) ||
        theme.palette.activeSecondaryHighlight;
    return __assign(__assign(__assign({}, theme.palette), pureColors), { activePrimaryHighlight: activePrimaryHighlight, activeSecondaryBackground: activeSecondaryBackground, activeSecondaryHighlight: activeSecondaryHighlight });
};
var buildIcons = function (icons) { return (__assign(__assign({}, theme.icons), icons.toJS())); };
export var selectThemeState = function (state) { return state.get('theme'); };
export var selectTheme = createSelector(selectThemeState, function (themeState) {
    return themeState.get('data');
});
export var selectThemeLoading = createSelector(selectThemeState, function (themeState) { return themeState.get('loading'); });
export var selectFullTheme = createSelector(selectTheme, function (themeData) {
    if (themeData.size > 0) {
        return fromJS(__assign(__assign({}, theme), { palette: buildPalette(themeData.get('colors')), reversePalette: reversePalette(buildPalette(themeData.get('colors'))), icons: buildIcons(themeData.get('icons')), logoUrl: themeData.get('logoUrl'), customerId: themeData.get('customerId'), customerWelcomeImage: themeData.get('customerWelcomeImage'), privacyPolicy: themeData.get('privacyPolicy'), imprint: themeData.get('imprint'), cookies: themeData.get('cookies'), conditions: themeData.get('conditions'), shipping: themeData.get('shipping'), cancellationPolicy: themeData.get('cancellationPolicy'), paypal: themeData.get('paypal'), servicePhone: themeData.get('servicePhone'), deliveryTerms: themeData.get('deliveryTerms'), aboutUs: themeData.get('aboutUs'), switches: themeData.get('switches'), clickAndCollect: themeData.get('clickAndCollect'), clickAndReserve: themeData.get('clickAndReserve'), clickAndDeliver: themeData.get('clickAndDeliver') }));
    }
    return fromJS(theme);
});
export var selectWelcomeImage = createSelector(selectTheme, function (themeData) {
    if (themeData.size > 0 && themeData.get('customerWelcomeImage')) {
        return themeData.get('customerWelcomeImage');
    }
    return theme.customerWelcomeImage;
});
export var selectCheckoutMessage = createSelector(selectTheme, function (themeData) {
    if (themeData.size > 0 && themeData.get('paypal')) {
        var paypal = themeData.get('paypal');
        return paypal.get('message') || '';
    }
    return theme.paypal;
});
